export enum AccountPlan {
  Starter = 'starter',
  Basic = 'basic',
  Professional = 'professional',
  Enterprise = 'enterprise',
}

export enum ShippingInfo {
  ProgressBar = 'progress_bar',
  OrderDetail = 'order_detail',
  TrackingLogs = 'tracking_logs',
  Map = 'map',
  TrackingCompany = 'tracking_company',
}

export enum ProgressBar {
  Ordered = 'Ordered',
  OrderReady = 'Order Ready',
  InTransit = 'In transit',
  OutForDelivery = 'Out for delivery',
  Delivered = 'Delivered',
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum DisplayComment {
  Checked = '1',
  UnChecked = '0',
}

export enum Subscription {
  Monthly = 'monthly',
  Annually = 'annually',
}

export enum CRUD {
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}

export enum Language {
  Default = '',
  English = 'en',
  Chinese = 'zh-CN',
  French = 'fr',
  Dutch = 'nl',
  Germany = 'de',
  Japanese = 'ja',
  Hebrew = 'he',
  Portuguese = 'pt-BR',
  Spanish = 'es',
  Arabic = 'ar',
}

export enum LanguageStatus {
  Default = 'default',
  Published = 'published',
  Unpublished = 'unpublished',
}

export enum DetectionMethod {
  ShopLocale = 'shop_locale',
  ShopifyMarkets = 'shopify_markets',
  Ip = 'ip',
  Url = 'url',
  Browser = 'browser',
}

export enum PageSize {
  Five = 5,
  TwentyFive = 25,
  Fifty = 50,
  SeventyFive = 75,
  OneHundred = 100,
}

export enum TrackingPageTheme {
  Basic = 1,
  Advanced = 2,
}

export enum TrackingMethods {
  Both = 'both',
  OrderId = 'order_name',
  Email = 'email',
  PhoneNumber = 'phone_number',
  TrackingNumber = 'tracking_number',
}

export enum GoogleTranslatePosition {
  LeftTop = 'leftTop',
  LeftBottom = 'leftBottom',
  RightTop = 'rightTop',
  RightBottom = 'rightBottom ',
}

export enum ProductRecommendType {
  AllProduct = 'all',
  productType = 'type',
  Tags = 'tags',
  SpecificProducts = 'products',
  Collections = 'collections',
}

// TR-559: recommendation engine source.
export enum RecommendSource {
  Rule = 'rule',
  Shopify = 'shopify',
}

// TR-506 R7: recommendation sort order. Encoded "<SORT_KEY>:<reverse>".
export const SORT_DEFAULT_PRODUCTS = 'CREATED_AT:true';
export const SORT_DEFAULT_COLLECTIONS = 'CREATED:true';

export const SORT_OPTIONS_PRODUCTS = [
  { label: 'Created (Newest first)', value: 'CREATED_AT:true' },
  { label: 'Created (Oldest first)', value: 'CREATED_AT:false' },
];

export const SORT_OPTIONS_COLLECTIONS = [
  { label: 'Created (Newest first)', value: 'CREATED:true' },
  { label: 'Created (Oldest first)', value: 'CREATED:false' },
  { label: 'Best selling', value: 'BEST_SELLING:false' },
  { label: 'Collection default', value: 'COLLECTION_DEFAULT:false' },
];

export const normalizeSortBy = (sortBy: string | undefined, type: string): string => {
  const isCollections = type === ProductRecommendType.Collections;
  const validKeys = isCollections ? ['CREATED', 'BEST_SELLING', 'COLLECTION_DEFAULT'] : ['CREATED_AT'];
  const key = (sortBy ?? '').split(':')[0];
  if (validKeys.includes(key)) return sortBy as string;
  return isCollections ? SORT_DEFAULT_COLLECTIONS : SORT_DEFAULT_PRODUCTS;
};

export enum DisplayReview {
  StarRating = 'star_rating',
  Comment = 'comment',
  CustomerName = 'customer_name',
  ReviewTime = 'review_time',
  Courier = 'courier',
}

export enum WidgetTrackingForm {
  TrackingNumber = 'trackingNumber',
  OrderId = 'orderId',
  Both = 'both',
}
export enum WidgetSize {
  Medium = '16px',
  Large = '18px',
  Small = '12px',
}

export enum Alignment {
  Left = 'flex-start',
  Right = 'flex-end',
  Center = 'center',
}

export enum Receiver {
  Customer = 'customer',
  Merchant = 'merchant',
}

export enum PolarisBreakPoint {
  XS = '0rem',
  SM = '30.625rem', // 490px+
  MD = '48rem', // 768px+
  LG = '65rem', // 1040px+
  XL = '90rem', // 1440px+
}

export enum Device {
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}

export enum PricingPlanTag {
  NONE = 'none',
  RECOMMENDED = 'recommended',
  BEST_SELLER = 'best_seller',
}
